import PathologyChart from "../../../components/PathologyChart/PathologyChart";
import DiseaseMap from "../DiseaseMap/DiseaseMap";


export default function InteractiveMapAndChart() {
    return <section style={{background: "#00516320"}}>
        <DiseaseMap />
        <PathologyChart />
    </section>
}